if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalBound = false;
        this.closeTimer = null;
      }

      connectedCallback() {
        super.connectedCallback();
        if (this.modalBound) return;
        this.modalBound = true;
        this.content = this.querySelector('[data-rp-modal-content]');
        this.previousButton = this.querySelector('[data-rp-modal-prev]');
        this.nextButton = this.querySelector('[data-rp-modal-next]');
        this.counter = this.querySelector('[data-rp-modal-counter]');
        this.liveRegion = this.querySelector('[data-rp-modal-live]');
        this.dialog = this.querySelector('.product-media-modal__dialog');

        this.previousButton?.addEventListener('click', () => this.showRelativeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showRelativeMedia(1));
        this.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target : null;
          const activeMedia = target?.closest('.rp-product-modal-media.active');
          const clickedControl = target?.closest('.product-media-modal__toggle, .rp-product-modal__controls, button, a, .product__media-toggle');
          const clickedVisual = target?.closest('img, video, iframe, model-viewer');
          if (!clickedControl && !clickedVisual && (target === this || target === this.dialog || target === this.content || (activeMedia && target === activeMedia))) {
            this.hide();
          }
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showRelativeMedia(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showRelativeMedia(1);
          }
        });
      }

      get mediaItems() {
        return this.content ? Array.from(this.content.children).filter((element) => element.matches('.rp-product-modal-media[data-media-id]')) : [];
      }

      show(opener) {
        if (this.closeTimer) {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        this.classList.remove('is-closing');
        super.show(opener);
        this.showActiveMedia();
      }

      hide() {
        this.mediaItems.forEach((item) => item.querySelectorAll('video').forEach((video) => video.pause()));
        if (!this.hasAttribute('open') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          super.hide();
          return;
        }

        this.classList.add('is-closing');
        if (this.closeTimer) window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => {
          this.classList.remove('is-closing');
          this.closeTimer = null;
          super.hide();
        }, 210);
      }

      showRelativeMedia(step) {
        const items = this.mediaItems;
        if (items.length < 2) return;
        const activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('active')));
        const nextIndex = (activeIndex + step + items.length) % items.length;
        this.showActiveMedia(items[nextIndex].getAttribute('data-media-id'));
      }

      showActiveMedia(mediaId) {
        const items = this.mediaItems;
        if (!items.length) return;

        const requestedId = mediaId || this.openedBy?.getAttribute('data-media-id');
        const activeMedia = items.find((element) => element.getAttribute('data-media-id') === requestedId) || items[0];
        const previousMedia = items.find((element) => element.classList.contains('active'));

        if (previousMedia && previousMedia !== activeMedia) {
          previousMedia.querySelectorAll('video').forEach((video) => video.pause());
        }
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();

        this.classList.remove('rp-media-ready');
        items.forEach((element) => {
          const isActive = element === activeMedia;
          element.classList.toggle('active', isActive);
          element.setAttribute('aria-hidden', String(!isActive));
        });
        this.updateControls(items, activeMedia);
        this.updateLiveRegion(items, activeMedia);

        const deferredMedia = activeMedia.querySelector('deferred-media, product-model');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') deferredMedia.loadContent();

        const image = activeMedia.querySelector('img');
        const ready = image && typeof image.decode === 'function' ? image.decode().catch(() => undefined) : Promise.resolve();
        ready.finally(() => {
          if (activeMedia.classList.contains('active')) this.classList.add('rp-media-ready');
        });
      }

      updateLiveRegion(items, activeMedia) {
        const index = Math.max(0, items.indexOf(activeMedia));
        const type = activeMedia.dataset.mediaType || 'media';
        const title = activeMedia.dataset.mediaTitle || activeMedia.querySelector('img')?.alt || '';
        if (this.counter) this.counter.textContent = `${index + 1} / ${items.length}`;
        if (this.liveRegion) this.liveRegion.textContent = `${type} ${index + 1} sur ${items.length}${title ? ` : ${title}` : ''}`;
      }

      updateControls(items, activeMedia) {
        const hasNavigation = items.length > 1;
        if (this.previousButton) this.previousButton.disabled = !hasNavigation;
        if (this.nextButton) this.nextButton.disabled = !hasNavigation;
        if (this.counter) this.counter.textContent = `${Math.max(0, items.indexOf(activeMedia)) + 1} / ${items.length}`;
      }
    }
  );
}